var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRIconNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "R_Icon_Network") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-\\u2013-Iconography",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R_Icon_Network"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container",
    opacity: 0,
    fill: "#DDDDDD"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3, 3.5)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6363636,13 L11.6363636,11.5555556 C11.6363636,9.96006628 10.3339193,8.66666667 8.72727273,8.66666667 L2.90909091,8.66666667 C1.30244436,8.66666667 0,9.96006628 0,11.5555556 L0,13",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 5.81818182,
    cy: 2.88888889,
    rx: 2.90909091,
    ry: 2.88888889
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "11.6363636 5.77777778 13.0909091 7.22222222 16 4.33333333"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIconNetwork);
export default __webpack_public_path__ + "static/media/R_Icon_Network.2d44879742378b61c5fa3c35f2a0308a.svg";
export { ForwardRef as ReactComponent };